var $ = require("jquery");
var $mobileNav = $("#mobile-menu");
var $iconWrapper = $("#menu_mobile_toggle");
var $bugerMenu = $(".navigationToggle");
var $body = $("body");

$bugerMenu.on("click", function () {
  $bugerMenu.toggleClass("open");
  $iconWrapper.toggleClass("open");
  $body.toggleClass("no-scroll");
  $mobileNav.toggleClass("navigation-visible");
});

const $window = $(window);

$window.resize(function () {
  if ($window.width() > 1000) {
    $mobileNav.removeClass("navigation-visible");
    $bugerMenu.removeClass("open");
  } else {
    $iconWrapper.addClass("open");
  }
});

// close nav if scroll to section
$(".anchor").on("click", function () {
  $(".navigationToggle").toggleClass("open");
  $bugerMenu.removeClass("open");
  $iconWrapper.toggleClass("open");
  $body.toggleClass("no-scroll");
  $mobileNav.toggleClass("navigation-visible");
});

/**
 * CLICK Listener
 * include all click-event-handler
 */
$(function () {
  // slide submenu of mobile navigation
  $(".mobile-menu-points span").on("click", function () {
    $(this).toggleClass("color-primary");
    $(this).toggleClass("opened");
    $(this).next("ul").slideToggle();
    $(this).children(".nav-chevron").toggleClass("toggle");
  });
});
